export const DropdownWidgetId = 'DropdownWidget';

export enum DropdownWidgetAttributes {
  LABEL = 'label',
  PLACEHOLDER = 'placeholder',
  ITEMS = 'items',
  DEFAULT_VALUE = 'defaultValue',
  DISABLED = 'disabled',
}
